module.exports = __webpack_public_path__ + "media/images/area/area_kagoshimaM400-3b309c967bd0e1f73177c92359cb323b.jpg";